import React, { useState } from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { Route, Switch, HashRouter as Router } from "react-router-dom";
import MSemic from "./views/m4k/semic/index";
import MBattery from "./views/m4k/battery/index";
import MTriangle from "./views/m4k/triangle/index";

import Semic from "./views/default/semic/index";
import Battery from "./views/default/battery/index";
import Triangle from "./views/default/triangle/index";
import echarts_default_global from "./echarts_default_global";
const useStyle = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100vw",
      height: "100vh",
      boxSizing: "border-box",
      background: "#272c4a",
      color: function () {
        return echarts_default_global.color[0];
      },
    },
    content: {},
  })
);

const App = () => {
  const classes = useStyle();
  return (
    <Router>
      <div className={classes.root}>
        <Switch>
          <Route exact path="/" component={Semic} />
          <Route path="/battery" component={Battery} />
          <Route path="/triangle" component={Triangle} />
          <Route path="/ms" component={MSemic} />
          <Route path="/mb" component={MBattery} />
          <Route path="/mt" component={MTriangle} />
          <Route path="/*" component={Semic} />
        </Switch>
      </div>
    </Router>
  );
};

export default App;
